import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import Categories from "./components/Categories";
import Completed from "./components/Completed";
import Fansub from "./components/Fansub";
import Picks from "./components/Picks";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs } from "@/mocks/comicData";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <Hero onSearch={setSearchQuery} />
        <Ranking searchQuery={searchQuery} />
        <Categories />
        <Completed />
        <Fansub />
        <Picks />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}